import * as z from "zod/v4";

export const getShopifyExtensionTeamInfo = {
  name: "getShopifyExtensionTeamInfo" as const,
  input: z.null(),
  output: z.object({
    teamId: z.string(),
    storeUrl: z.string(),
    widgetId: z.string(),
    shouldLoginUsingMultipass: z.boolean(),
  }),
};
